import { render } from "./LoadGameForm.vue?vue&type=template&id=a7d53626&ts=true"
import script from "./LoadGameForm.vue?vue&type=script&lang=ts"
export * from "./LoadGameForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__